import { render, staticRenderFns } from "./AverageTooltip.vue?vue&type=template&id=0d5490b8&scoped=true"
import script from "./AverageTooltip.vue?vue&type=script&lang=js"
export * from "./AverageTooltip.vue?vue&type=script&lang=js"
import style0 from "./AverageTooltip.vue?vue&type=style&index=0&id=0d5490b8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5490b8",
  null
  
)

export default component.exports